<app-grid
[gridBulkSection]=gridBulkSection
[gridColumnsParam]=gridColumnsParam
[gridFilter]=gridFilter
[gridPanelPreferences]=gridPanelPreferences
[gridSearch]=gridSearch
[sectionMessage]=gridSectionMessage
(onGetGridData)="getPaymentRunByPendingStatus()">
  <mat-list class="custom-mat-list list-grid-std list-billing-operations list-next-bill-run">
    <mat-list-item *ngIf="_skeleton.skeletonGridDataLoader" class="custom-mat-list-item grid-row grid-row-header">
      <div class="cell-wrapper col-first">
        <div class="cell flex-order order-0">
          <label matLine class="label-header">Target Date</label>
        </div>
      </div>
      <div class="cell-wrapper col-info">
        <div class="cell flex-order order-1">
          <label matLine class="label-header">Time Remaining</label>
        </div>
        <div class="cell flex-order order-2">
          <label matLine class="label-header">Repeat</label>
        </div>
        <div class="cell flex-order order-3">
          <label matLine class="label-header">Status</label>
        </div>
      </div>
      <div class="cell-wrapper col-actions">
        <div class="cell"></div>
      </div>
    </mat-list-item>
    <div *ngIf="_skeleton.skeletonGridDataLoader">
      <mat-list-item *ngFor="let item of collectionOfPaymentRunPending; let i = index;" class="custom-mat-list-item grid-row">
        <div class="cell-wrapper col-first">
          <div class="cell col-target-date">
            <div class="cell-inner">
              <label matLine class="label-primary">{{item.targetDate | dateTz  }}</label>
              <label matLine class="label-secondary">{{item.targetDate | dateTz: 'longTime' }}</label>
            </div>
          </div>
        </div>
        <div class="cell-wrapper col-info">
          <div class="cell flex-order order-1">
            <label *ngIf="countdownTime !== null && !countdownTime.completed" matLine class="label-primary">
              <span class="typo title fw400">{{countdownTime.days}} </span><span class="typo note fw300">DAYS </span>
              <span class="typo title fw400">{{countdownTime.hours}} </span><span class="typo note fw300">HRS</span>
              <span class="typo title fw400"> {{countdownTime.minutes}} </span><span class="typo note fw300">MIN</span>
              <span class="typo title fw400"> {{countdownTime.sec}} </span><span class="typo note fw300">SEC</span>
            </label>
            <label *ngIf="countdownTime === null" matLine class="label-primary">Calculating Remaing Time</label>
            <label *ngIf="countdownTime && countdownTime.completed" matLine class="label-primary">Running</label>
          </div>
          <div class="cell flex-order order-2">
            <label matLine class="label-primary">{{item.repeatType | titlecase}}</label>
          </div>
          <div class="cell flex-order order-3">
            <label matLine *ngIf="item.status === _paymentRunStatus.completed" class="label-primary">Completed</label>
            <label matLine *ngIf="item.status === _paymentRunStatus.completedWithErrors" class="label-primary">Completed With Errors</label>
            <label matLine *ngIf="item.status === _paymentRunStatus.error" class="label-primary">Error</label>
            <label matLine *ngIf="item.status === _paymentRunStatus.pending" class="label-primary">Pending</label>
            <label matLine *ngIf="item.status === _paymentRunStatus.processing" class="label-primary">Processing</label>
          </div>
        </div>
        <div class="cell-wrapper col-actions">
          <button mat-icon-button [matMenuTriggerFor]="billingActions" class="custom-mat-icon-button button-actions">
            <mat-icon svgIcon="ico-actions" class="custom-mat-icon ico-size ico-xs"></mat-icon>
          </button>
          <mat-menu #billingActions="matMenu" class="custom-mat-menu-panel">
            <button [disabled]="'feature_payrun_changeTime|enabled|SCOPE_BUTTON_DISABLE'" mat-menu-item (click)="showChangePaymentTargetDate(i)" class="custom-mat-menu-item">
              <mat-icon svgIcon="ico-schedule" class="custom-mat-icon ico-size ico-1xs"></mat-icon>Change Time
            </button>
            <button *appRestriction="'feature_payrun_runnow|enabled|SCOPE_HIDE'" mat-menu-item (click)="showDialogRunPaymentNow(i)" class="custom-mat-menu-item">
              <mat-icon svgIcon="ico-run" class="custom-mat-icon ico-size ico-1xs"></mat-icon>Run Now
            </button>
          </mat-menu>
        </div>
      </mat-list-item>
    </div>
    <skeleton-loader-grid-header [gridBulkSection]=false></skeleton-loader-grid-header>
    <skeleton-loader-grid-body [gridBulkSection]=false [numberOfRows]=1></skeleton-loader-grid-body>
  </mat-list>
</app-grid>
